import './theme/colors.css'
import './theme/globals.css'

import { PostHogProvider } from '@posthog/react'
import { RouterProvider, createRouter } from '@tanstack/react-router'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { initLinkedInInsight } from './integrations/linkedin-insight'
import { initMetaPixel, trackMetaPageView } from './integrations/meta-pixel'
import { initPostHog } from './integrations/posthog'
import { initSentry } from './integrations/sentry'
import { routeTree } from './routeTree.gen'

const router = createRouter({ routeTree })

// Sentry's TanStack Router instrumentation needs the router instance, so it is built first.
initSentry(router)
initMetaPixel()
initLinkedInInsight()

const posthogClient = initPostHog()

// A SPA navigation never reloads the document, so the Meta Pixel would otherwise
// only ever report the landing route as a PageView.
router.subscribe('onResolved', ({ toLocation }) => {
  trackMetaPageView(toLocation.pathname)
})

declare module '@tanstack/react-router' {
  type Register = {
    router: typeof router
  }
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <PostHogProvider client={posthogClient}>
      <RouterProvider router={router} />
    </PostHogProvider>
  </StrictMode>,
)
